import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import './CreateFlowHero.css';

export type CreateFlowHeroProps = {
  badge: string;
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
  onBack?: () => void;
  backLabel?: string;
  actions?: React.ReactNode;
};

const CreateFlowHero: React.FC<CreateFlowHeroProps> = ({
  badge,
  title,
  subtitle,
  icon,
  onBack,
  backLabel = 'Back',
  actions,
}) => (
  <div className="cf-hero">
    <div className="cf-hero-deco cf-hero-deco-1" />
    <div className="cf-hero-deco cf-hero-deco-2" />
    {icon && <div className="cf-hero-deco cf-hero-deco-3">{icon}</div>}
    <div className="cf-hero-top">
      <div>
        <div className="cf-badge">
          <span className="cf-badge-dot" />
          {badge}
        </div>
        <h1 className="cf-hero-title">{title}</h1>
        <p className="cf-hero-sub">{subtitle}</p>
      </div>
      {(onBack || actions) && (
        <div className="cf-hero-actions">
          {actions}
          {onBack && (
            <button type="button" className="cf-back-btn" onClick={onBack}>
              <BsArrowLeft /> {backLabel}
            </button>
          )}
        </div>
      )}
    </div>
  </div>
);

export default CreateFlowHero;
